import React from "react";
import ProfilePageHeader from "components/Headers/ProfilePageHeader";

import Navbar from "components/Navbar";
import Footer from "components/Footer";
import AboutPage from "components/AboutPage";

import {} from "./content";

import ScrollUpButton from "react-scroll-up-button";

function About() {
  return (
    <div id="outer-container">
      <div
        style={{
          background: "#000",
          backgroundImage: "url(" + require("assets/images/services_bg.jpg") + ")",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
          backgroundSize: "cover",
        }}
      >
        <Navbar />
        <ScrollUpButton />
        <ProfilePageHeader title="ABOUT" />
        <AboutPage />
        <Footer />
      </div>
    </div>
  );
}

export default About;
